import { Table, TableColumnsType } from 'antd'
import React from 'react'
import { Typography } from '@mui/material'
import CircularLoading from '../../../../../../../components/CircularProgress'
import {
  ILeadAssignTo,
  ITrackingNotificationsGetReportAssignTo,
} from '../../../../../../../types/trackingNotification'
import { numberFormat } from '../../../../../../../utils'

interface ILeadListNotificationTableProps {
  onPressRow: (assignTo: ILeadAssignTo) => void
  isLoading: boolean
  data?: ITrackingNotificationsGetReportAssignTo[]
}

const LeadListNotificationTable = ({
  onPressRow,
  isLoading,
  data,
}: ILeadListNotificationTableProps) => {
  const columns: TableColumnsType<
    ITrackingNotificationsGetReportAssignTo & { key: number }
  > = [
    {
      title: 'ลำดับ',
      dataIndex: 'numberRow',
      key: 'numberRow',
      width: 80,
      align: 'center' as const,
      render: (numberRow: number) => {
        return (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            textAlign={'center'}
          >
            {numberRow}
          </Typography>
        )
      },
    },
    {
      title: 'โดย',
      dataIndex: 'assignTo',
      key: 'assignTo',
      align: 'center' as const,
      render: (assignTo: ILeadAssignTo) => {
        return (
          <Typography
            variant="subtitle2"
            textAlign={'left'}
            sx={{ color: 'success.main', cursor: 'pointer' }}
            minWidth={100}
            onClick={() => onPressRow(assignTo)}
          >
            {assignTo?.name}
          </Typography>
        )
      },
    },
    {
      title: 'ทั้งหมด',
      dataIndex: 'item',
      key: 'item',
      align: 'center' as const,
      render: (item: number) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'center'}
            minWidth={50}
          >
            {item.toLocaleString()}
          </Typography>
        )
      },
    },
    {
      title: 'ติดตามแล้ว',
      dataIndex: 'success',
      key: 'success',
      align: 'center' as const,
      render: (success: number) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'center'}
            minWidth={50}
          >
            {success.toLocaleString()}
          </Typography>
        )
      },
    },
    {
      title: 'ยังไม่ติดตาม',
      dataIndex: 'unSuccess',
      key: 'unSuccess',
      align: 'center' as const,
      render: (unSuccess: number) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'center'}
            minWidth={50}
          >
            {unSuccess.toLocaleString()}
          </Typography>
        )
      },
    },
  ]

  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Table
        size={'middle'}
        columns={columns}
        scroll={{
          x: columns.reduce(
            (pre, cur: any) => (cur.width ? cur.width + pre : pre),
            0,
          ),
        }}
        dataSource={data?.map(
          (expense: ITrackingNotificationsGetReportAssignTo, index: number) => {
            return {
              ...expense,
              key: index,
              numberRow: index + 1,
            }
          },
        )}
        bordered
        pagination={false}
        summary={() => (
          <>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  textAlign={'center'}
                >
                  รวม
                </Typography>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} colSpan={1}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  textAlign={'center'}
                >
                  {numberFormat(
                    data?.reduce((pre, cur) => pre + cur.item, 0) || 0,
                  )}
                </Typography>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} colSpan={1}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  textAlign={'center'}
                >
                  {numberFormat(
                    data?.reduce((pre, cur) => pre + cur.success, 0) || 0,
                  )}
                </Typography>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={4} colSpan={1}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  textAlign={'center'}
                >
                  {numberFormat(
                    data?.reduce((pre, cur) => pre + cur.unSuccess, 0) || 0,
                  )}
                </Typography>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </>
        )}
      />
    </>
  )
}

export default LeadListNotificationTable
